import React, { Component } from 'react';
import _ from 'lodash';
import { MyPATLink } from '../../common';
import { withStyles } from '@material-ui/core/styles'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Grid,
  Checkbox,
  Typography,
  WithStyles,
} from '@material-ui/core';

import Paper from '@material-ui/core/Paper';

import {
  AccessTime as BackIcon,
} from '@material-ui/icons';
import { styles } from '../styling/coursePlaneRoadMap'
import { CourseBasicInfo } from '../modals/CourseBasicInfo';
import { CourseMilestoneDetails } from '../modals/CourseMilestoneDetail';

interface CoursePlaneRoadMapProps extends WithStyles<typeof styles> {
  milestoneData: CourseMilestoneDetails[]
  courseDetails: CourseMilestoneDetails
  courseID: string
  milestoneCommonAction: Function
  mileStoneAction: any

};

interface CoursePlaneRoadMapStates {
}
class CoursePlaneRoadMap extends Component<CoursePlaneRoadMapProps, CoursePlaneRoadMapStates>{
  constructor(props: CoursePlaneRoadMapProps) {
    super(props);

  }
  // componentDidUpdate(prevProps:any) {
  //   if (this.props.mileStoneAction !== prevProps.mileStoneAction) {

  //   }
  // }

  render() {
    const { classes, courseID, courseDetails, milestoneData, milestoneCommonAction, mileStoneAction } = this.props;
    let draftCompletionPercentage = 0;
    let remainingChapters = 0;
    if (courseDetails) {
      draftCompletionPercentage = courseDetails.draftCompletionPercentage;
      remainingChapters = courseDetails.remainingChapter;
    }
    return (
      <Grid container
        spacing={0}
        direction="column"
      >
        <Grid item xs={10} className={classes.root}>
          {
            milestoneData.map(function (value: any, index: any) {
              let rows = "";
              if (value) {
                for (var k in value.contentTypes) {
                  rows += ' ' + value.contentTypes[k] + ' ' + k + ' '
                }
              }
              return <div>
                {index == 0 ? <Grid container style={{ position: "relative" }}>
                  <Grid item xs={1}><img alt="station" className={classes.start} src="/assets/img/coursemapplane/station.png" /></Grid>
                  <Grid item xs={6} className={classes.startText}>
                  </Grid>
                </Grid> : ""}
                <Grid container>
                  <Grid item xs={2}>
                    <img alt="leftline" className={classes.img} src="/assets/img/coursemapplane/leftline.png" /></Grid>
                  <Grid item xs={1}>
                    <img alt="mark" className={`${classes.mark} ${classes.markImg}`} style={{ position: "absolute", left: "362px" }} src="/assets/img/coursemapplane/mark.png" /></Grid>

                  {
                    value.isRevisionMilestone == false ?
                      <Grid item xs={5}>

                        <Paper elevation={5} className={classes.leftCard}>
                          <div key={index}>

                            <Typography style={{ fontSize: "16px", lineHeight: "11px", textAlign: "center" }} variant="body2">{value.name}
                              <Checkbox id="checkbox" key={value._id} className={classes.checkBox} value={value._id} onChange={(e: any) => { milestoneCommonAction(e) }}
                                color="primary"
                                checked={mileStoneAction.includes(value._id)}

                              />
                            </Typography>
                            <MyPATLink to={`/course/milestoneDetail/${courseID}/${value._id}`}>
                              <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1}> <Typography style={{ marginLeft: "30px", }} variant="body2"><BackIcon style={{ width: "16px", height: "16px", marginBottom: "4px" }} /> </Typography> </Grid>
                                <Grid item xs={3}> <Typography style={{ marginLeft: "26px", color: "#666666", fontSize: "14px" }} variant="body2">{value.number}   {value.tentativeDuration} </Typography> </Grid>
                                <Grid item xs={2}> <img alt="GoalIcon" className={classes.goalIconImg} src="/assets/img/coursemapplane/GoalIcon.png" /></Grid>
                                <Grid item xs={3}> <Typography style={{ marginLeft: "-34px", color: "#B08A2A", fontSize: "14px" }} variant="body2">Phase test 1</Typography> </Grid>
                              </Grid>
                              <Typography style={{ textAlign: "center", lineHeight: "22px" }} variant="body2" className={classes.assignmentText}>{value.milestoneAssignment || 0} Assignments</Typography>
                              <Typography style={{ fontSize: "13px", textAlign: "center", lineHeight: "22px" }} variant="body1">{rows}
                              </Typography>
                            </MyPATLink>
                          </div>
                        </Paper>

                      </Grid>
                      :

                      <Grid item xs={5} >

                        <Paper elevation={5} className={classes.leftCard} style={{ border: "1px solid #507CB8" }}>
                          <div key={index}>

                            <Typography style={{ fontSize: "16px", lineHeight: "11px", textAlign: "center" }} variant="body2">{value.name}
                              <Checkbox id="checkbox" key={value._id} className={classes.checkBox} value={value._id} onChange={(e: any) => { milestoneCommonAction(e) }}
                                color="primary"
                                checked={mileStoneAction.includes(value._id)}

                              />
                            </Typography>
                            <MyPATLink to={`/course/milestoneDetail/${courseID}/${value._id}`}>
                              <Grid container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1}> <Typography style={{ marginLeft: "30px", }} variant="body2"><BackIcon style={{ width: "16px", height: "16px", marginBottom: "4px" }} /> </Typography> </Grid>
                                <Grid item xs={3}> <Typography style={{ marginLeft: "26px", color: "#666666", fontSize: "14px" }} variant="body2">{value.number}   {value.tentativeDuration} </Typography> </Grid>
                                <Grid item xs={2}> <img alt="GoalIcon" className={classes.goalIconImg} src="/assets/img/coursemapplane/Goal_Icon_Blue.png" /></Grid>
                                <Grid item xs={3}> <Typography style={{ marginLeft: "-34px", color: "#507CB8", fontSize: "14px" }} variant="body2" >Combined test 1</Typography> </Grid>
                              </Grid>
                              <Typography style={{ textAlign: "center", lineHeight: "22px" }} variant="body2" className={classes.assignmentText}><img alt="milestone" src="/assets/img/coursemapplane/milestone.png" style={{ height: "20px", marginBottom: "-5px", marginRight: "7px" }} />Milestone {_.map(value.milestoneIncluded, (data: any, i: number) => {
                                if (i != value.milestoneIncluded.length - 1) {
                                  return `${data} + `
                                }
                                else {
                                  return `${data}`
                                }

                              })}</Typography>
                              <Typography style={{ fontSize: "13px", textAlign: "center", lineHeight: "22px" }} variant="body1">{rows}
                              </Typography>
                            </MyPATLink>
                          </div>
                        </Paper>

                      </Grid>
                  }
                </Grid>


                {value.tests.length > 0 ?
                  value.tests.map(function (v: any, i: any) {
                    return <Grid container>
                      <Grid item xs={1}>
                        <img alt="rightline" className={classes.img} src="/assets/img/coursemapplane/rightline.png" />

                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="body2" className={classes.subHeaderText}></Typography>

                        <Paper elevation={5} className={classes.rightCard}>
                          <div key={i}>
                            <Typography style={{ textAlign: "center" }} variant="body2" className={classes.testHeader}>{v.name}</Typography>
                            <Typography style={{ textAlign: "center" }} variant="body1" className={classes.testDate}>{v.testDate}</Typography>
                            <Typography style={{ textAlign: "center" }} variant="body2">{v.conceptCount} Concepts    {v.data.questionsCount || 0} Questions</Typography>
                          </div>
                        </Paper>
                        <Grid item xs={2}>
                          <img alt="panel" className={classes.markpanels} src="/assets/img/coursemapplane/panel.png" />
                        </Grid>
                      </Grid>
                    </Grid>
                  })
                  : <Grid container>
                    <Grid item xs={1}>
                      <img alt="rightline" className={classes.img} src="/assets/img/coursemapplane/rightline.png" />
                    </Grid></Grid>}

              </div>
            })
          }
          {draftCompletionPercentage == 100 ?
            <div>
              <img alt="goal" className={classes.goalcourse} src="/assets/img/coursemapplane/goal.png" />
              <Typography variant="h6" className={classes.goalText}>Goal Complete</Typography>
            </div> : <Grid container xs={12}>
              <Grid item xs={3} className={classes.circle_bg_pos_rel}>
                <img className={classes.mileStoneImg} src="/assets/img/course/milestone-bg.png" alt="milestone" />
                <Grid container className={classes.textBarNega}> {milestoneData.length || 0}</Grid>
                <Grid container className={classes.textBarNega2}> Chapters <br />to cover</Grid>
                <Grid container className={classes.textBarNega3}> Add More Milestones</Grid>
                <Grid container className={classes.textBarNega4}> You have {remainingChapters || 0} chapters remaining <br />
                  to be added in milestones</Grid>
              </Grid>
            </Grid>}
        </Grid>
      </Grid>
    );
  }
};
const mapStateToProps = (state: any) => ({
}
);

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
  },
  dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CoursePlaneRoadMap));

